// LocalStorage cart + visitor tracking management

const CART_KEY = 'anx_cart';
const VISITOR_KEY = 'anx_visitor_id';

export const getVisitorId = () => {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = 'V_' + Date.now() + '_' + Math.random().toString(36).substring(2, 10);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
};

export const getCart = () => {
  try {
    const cart = localStorage.getItem(CART_KEY);
    return cart ? JSON.parse(cart) : [];
  } catch (error) { return []; }
};

export const addToCart = (product) => {
  try {
    const cart = getCart();
    const idx = cart.findIndex(item => item.sku === product.sku);
    if (idx >= 0) cart[idx].quantity = (cart[idx].quantity || 1) + 1;
    else cart.push({ ...product, quantity: 1 });
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    return cart;
  } catch (error) { return []; }
};

export const removeFromCart = (sku) => {
  try {
    const cart = getCart().filter(item => item.sku !== sku);
    localStorage.setItem(CART_KEY, JSON.stringify(cart));
    return cart;
  } catch (error) { return []; }
};

export const updateCartQuantity = (sku, quantity) => {
  try {
    const cart = getCart();
    const item = cart.find(item => item.sku === sku);
    if (item) {
      item.quantity = quantity;
      if (quantity <= 0) return removeFromCart(sku);
      localStorage.setItem(CART_KEY, JSON.stringify(cart));
    }
    return cart;
  } catch (error) { return []; }
};

export const clearCart = () => { localStorage.removeItem(CART_KEY); return []; };
export const getCartCount = () => getCart().reduce((t, i) => t + (i.quantity || 1), 0);

export const generateWhatsAppCartMessage = (cart) => {
  let message = "Hi, I'm interested in the following items from AHMEDABAD NX:\n\n";
  cart.forEach((item, i) => {
    message += `${i + 1}. ${item.title} (${item.sku}) - ${item.color} - ₹${item.price} x ${item.quantity}\n`;
  });
  const total = cart.reduce((s, i) => s + (i.price * i.quantity), 0);
  message += `\nTotal: ₹${total}\n\nPlease share more details and confirm availability.`;
  return encodeURIComponent(message);
};
